// @flow
import { useAuthContext } from 'auth/authContext'
import NotFoundPage from 'components/NotFoundPage'
import PrivateRoute from 'components/PrivateRoute'
import omit from 'lodash/omit'
import * as React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import routes from './routes'

function MainRouter(): React.Node {
  const { isAuthenticated } = useAuthContext()

  return (
    <Switch>
      {/* Private routes */}
      {routes
        .filter((route) => route.private)
        .map((route) => {
          const Component = route.component

          return (
            <PrivateRoute
              component={Component}
              exact={route.exact}
              key={route.path}
              path={route.path}
              route={omit(route, 'component')}
            />
          )
        })}
      {/* Public routes */}
      {routes
        .filter((route) => !route.private)
        .map((route) => {
          const Component = route.component

          return (
            <Route
              component={Component}
              exact={route.exact}
              key={route.path}
              path={route.path}
            />
          )
        })}
      {/* Handle not found routes */}
      <Route
        render={() =>
          isAuthenticated ? (
            <Redirect to="/" />
          ) : (
            <NotFoundPage showHomeButton={false} />
          )
        }
      />
    </Switch>
  )
}

export default MainRouter
